import { render } from "./PartnerEdit.vue?vue&type=template&id=e9b08b8c"
import script from "./PartnerEdit.vue?vue&type=script&lang=js"
export * from "./PartnerEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__